// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"706":"39fdf011","781":"2ac24cd2"}[chunkId] + ".chunk.css";
};